import { SnailyError } from './SnailyError'

export class BadGatewayError extends SnailyError {
	constructor(message: string, metadata?: unknown) {
		super(message, metadata)
		this.name = 'BadGatewayError'

		if (typeof Error.captureStackTrace === 'function') {
			Error.captureStackTrace(this, BadGatewayError)
		}
	}

	get skipLogging(): boolean {
		return true
	}
}
